<script setup lang="ts">
import './assets/style.scss'
import LanguageSelect from '@/entities/Language'
import { computed } from 'vue'
import { DateTime } from 'ts-luxon'
import { VNotification } from '@/shared/ui'

const year = computed(() => DateTime.now().year)
</script>

<template>
  <VNotification />

  <div class="auth-layout">
    <div class="auth-layout__header">
      <LanguageSelect />
    </div>

    <div class="auth-layout__content">
      <div class="auth-layout__logo">
        <img src="/images/logo_lensvet.jpg" alt="lensvet" />
      </div>
      <slot />
    </div>

    <div class="auth-layout__footer">© 2000 - {{ year }} Unilight</div>
  </div>
</template>
